import { Box, createListCollection, Input, Text } from "@chakra-ui/react";
import {
  EyebrowBadge,
  FormField,
  OnboardingSelect,
  SectionCard,
} from "../components";
import type { CatalogItem, FormData } from "../types";

export function Step1BasicInfo({
  data,
  erps,
  updateData,
  fieldErrors,
}: {
  data: FormData;
  erps: CatalogItem[];
  updateData: (field: string, value: string | boolean) => void;
  fieldErrors: Record<string, string>;
}) {
  const erpCollection = createListCollection({ items: erps });

  return (
    <Box spaceY={8}>
      <Box spaceY={3}>
        <EyebrowBadge stepId={1} />
        <Box spaceY={2}>
          <Text
            fontSize="3xl"
            fontWeight="bold"
            color="gray.900"
            letterSpacing="tight"
          >
            Información básica
          </Text>
          <Text fontSize="lg" color="gray.500" maxW="2xl">
            Empecemos por lo esencial: el nombre del comercio y qué tan grande
            es la operación.
          </Text>
        </Box>
      </Box>

      <SectionCard
        title="Datos operativos"
        description="Esto nos ayuda a estimar el contexto de activación y los aliados que pueden sumarte valor."
      >
        <Box spaceY={6}>
          <FormField
            label="Nombre comercial"
            error={fieldErrors.nombreComercial}
          >
            <Input
              value={data.nombreComercial}
              onChange={(e) => updateData("nombreComercial", e.target.value)}
              placeholder="Nombre que verán tus clientes"
            />
          </FormField>
          <OnboardingSelect
            label="¿Qué ERP usas?"
            collection={erpCollection}
            value={data.erp}
            onValueChange={({ value }) => updateData("erp", value[0])}
            error={fieldErrors.erp}
          />
          {data.erp === "none" && (
            <FormField label="¿Cuál es tu ERP?" error={fieldErrors.otroErp}>
              <Input
                value={data.otroErp}
                onChange={(e) => updateData("otroErp", e.target.value)}
                placeholder="Escribe el nombre de tu ERP"
              />
            </FormField>
          )}
          <Box
            display="grid"
            gridTemplateColumns={{ base: "1fr", md: "1fr 1fr" }}
            gap={6}
          >
            <FormField
              label="Contratos estimados en administración"
              error={fieldErrors.contratos}
            >
              <Input
                type="number"
                value={data.contratos}
                onChange={(e) => updateData("contratos", e.target.value)}
                placeholder="Ej. 250"
              />
            </FormField>
            <FormField
              label="Cartera mensual aproximada de arrendamientos (COP)"
              error={fieldErrors.cartera}
            >
              <Input
                value={data.cartera}
                onChange={(e) => updateData("cartera", e.target.value)}
                placeholder="$ 1,500,000,000"
              />
            </FormField>
          </Box>
        </Box>
      </SectionCard>
    </Box>
  );
}
